{
  "bookmarks": [
    {
      "title": "🙂 Rien à signaler",
      "languages": {
        "fr": {
          "login": "",
          "app": "",
          "free": ""
        },
        "nl": {
          "login": "",
          "app": "",
          "free": ""
        }
      }
    },
    {
      "title": "⚠️ Incident eHealth",
      "languages": {
        "fr": {
          "login": "",
          "app": "<div><b>{date} :</b> Un incident est en cours chez eHealth. Vous pouvez suivre l'état de résolution sur <a href=\"https://www.status.ehealth.fgov.be/fr\" target=\"_blank\">la page des statuts de eHealth.</a></div>",
          "free": "<div><b>{date} :</b> Un incident est en cours chez eHealth. Vous pouvez suivre l'état de résolution sur <a href=\"https://www.status.ehealth.fgov.be/fr\" target=\"_blank\">la page des statuts de eHealth.</a></div>"
        },
        "nl": {
          "login": "",
          "app": "<div><b>{date} :</b> Er is momenteel een incident bij eHealth. U kunt de status van de oplossing volgen op <a href=\"https://www.status.ehealth.fgov.be/nl\" target=\"_blank\">de statutenpagina van eHealth.</a></div>",
          "free": "<div><b>{date} :</b> Er is momenteel een incident bij eHealth. U kunt de status van de oplossing volgen op <a href=\"https://www.status.ehealth.fgov.be/nl\" target=\"_blank\">de statutenpagina van eHealth.</a></div>"
        }
      }
    },
    {
      "title": "🚀 Nouvelle release",
      "languages": {
        "fr": {
          "login": "",
          "app": "<div><b>{date} :</b> Nouvelle version XX.YY avec fonctionnalité de XYZ (<a href=\"https://support.medispring.be/portal/fr/kb/articles/notes-de-version-XX-YY\" target=\"_blank\">Notes de version</a>)</div>",
          "free": ""
        },
        "nl": {
          "login": "",
          "app": "<div><b>{date} :</b> Nieuwe versie XX.YY met functionaliteit XYZ (<a href=\"https://support.medispring.be/portal/nl/kb/articles/release-notes-medispring-XX-YY\" target=\"_blank\">Release notes</a>)</div>",
          "free": ""
        }
      }
    },
    {
      "title": "📅 Maintenance planifiée",
      "languages": {
        "fr": {
          "login": "<div><b>{date} :</b> Maintenance prévue le XXX.</div>",
          "app": "<div><b>{date} :</b> Maintenance prévue le XXX.</div>",
          "free": "<div><b>{date} :</b> Maintenance prévue le XXX.</div>"
        },
        "nl": {
          "login": "<div><b>{date} :</b> Gepland onderhoud op XXX.</div>",
          "app": "<div><b>{date} :</b> Gepland onderhoud op XXX.</div>",
          "free": "<div><b>{date} :</b> Gepland onderhoud op XXX.</div>"
        }
      }
    }
  ]
}
